import React from "react";
import RegularImage from "../../../images/slides/slide-b.jpg";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
  BlockBetween,
  Button,
  Icon,
} from "../../../components/Component";
import { Label, Input, Row, Col } from "reactstrap";
const Header: React.FC = (props: any) => {
  const NavLables = [
    "General Information",
    // "Legal Information",
    "Contact Information",
    "Additional Contact Information",
    "Bank Account Details",
    // "Other Details",
  ];
  return (
    <>
      <div className="steps clearfix">
        <ul>
          {NavLables.map((item, index, array) => {
            if (index === array.length - 1) {
              return (
                <li
                  className={props.current === index + 1 ? "last done" : "last"}
                >
                  <a
                    href="#wizard-01-h-2"
                    onClick={(ev) => ev.preventDefault()}
                  >
                    <span className="current-info audible">current step: </span>
                    <span className="number">Step {index + 1}</span>
                    <h5>{item}</h5>
                  </a>
                </li>
              );
            }
            return (
              <li
                className={
                  props.current >= index + 1
                    ? `${index === 0 ? "first done" : "done"}`
                    : `${index === 0 ? "first" : ""}`
                }
              >
                <a
                  href={`#wizard-01-h-${index}`}
                  onClick={(ev) => ev.preventDefault()}
                >
                  <span className="current-info audible">current step: </span>
                  <span className="number">Step {index + 1}</span>{" "}
                  <h5>{item}</h5>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
export default Header;
